<template>
    <div v-loading="loading">
        <div class="chongzhi">
            <div class="tit">选择充值数额</div>
            <div class="list">
                <div v-for="(item,index) in list.arr"
                     :key="index"
                     :class="list.active == index?'active':''"
                     @click="list.active = index">
                    <div>{{item}}缩币</div>
                    <span>￥ {{item}}.00</span>
                </div>
            </div>
            <div>
                <el-input placeholder="请输入自定义充值金额"
                          v-model="price"
                          clearable>
                </el-input>
            </div>
            <hr />

            <div class="chongzhifangshi">
                <div>
                    <span @click="pay('wxpay')">微信</span>
                    <span @click="pay('alipay')">支付宝</span>
                </div>
            </div>

        </div>

        <div class="recharge_instructions">
            <div class="tit"> 缩水网充值说明：</div>
            1. 不能购彩和提现，仅用于查看缩水师推荐缩水单，技巧师推荐EXCEL表、软件交易师的软件以及投注站帮扶中心众筹招股，最少充值100元(1元=1缩币)
            <br />
            2、微信客服：hzck36886
            <br />
            3. 微信月限额5000元，支付宝月限额1000元。额度用完后，可以用银行汇款转账到公司其他账号继续充值
            <br />
            4. 银行汇款转账方式充值：我们收到汇款后，管理员会帮您充值缩币
            <br />
            5、查询记录：请在个人中心查看缩币记录；
            欢迎联系我们(8:30-21:30)：
            <br />
            夜间21:30~8:30无人工客服, 请微信或QQ留言
        </div>

        <el-dialog :visible.sync='qrCode.show'
                   :title="payTitle"
                   append-to-body>
            <div style="border: 1px solid #FFA500; display: flex; align-items: center; justify-content: center; height: 430px; margin-top: -25px; position: relative; ">
                <div style="position: absolute; top: 20px; right: 30px; font-weight: bold;">支付：{{ price || list.arr[list.active]}}元</div>

                <div ref="qrcode"
                     style="marginTop:20px"></div>

            </div>

        </el-dialog>

    </div>
</template>

<script>
import { balance } from '@/api/chongzhi'
import QRCode from 'qrcodejs2';
export default {
    data () {
        return {
            payTitle: '',
            price: '',
            list: {
                active: 0,
                arr: [5, 15, 30, 50, 100, 200, 500, 1000]
            },
            qrCode: {
                show: false,
                url: ''
            },
            loading: false,

            socket: null, // Socket连接对象

            ws: {},
        }
    },
    mounted () {


    },
    beforeDestroy () {
        // this.socket.disconnect(); // 断开Socket连接
    },
    methods: {
        pay (payType) {

            let params = `/${this.vuex_token}?userId=${this.vuex_userInfo.userId}&businessType=pay`
            // console.log('process.env.VUE_APP_BASE_WS', process.env);
            this.ws = new WebSocket(process.env.VUE_APP_BASE_WS + '/stage-api/pay-websocket' + params)
            this.ws.onopen = function (event) {
                console.log("WebSocket is open now.");
            };
            let that = this
            this.ws.onmessage = function (event) {
                console.log("Message from server ", event.data);
                let { code, msg } = JSON.parse(event.data)
                if (code == 200) {
                    that.qrCode.show = false
                }
                if (msg == '连接已建立') {
                    that.$message.success(msg)
                }
                if (msg == '支付成功') {
                    that.$alert(msg, '提示', {
                        confirmButtonText: '确定',
                    });
                    that.price = ''
                }
            }


            this.loading = true
            balance({
                money: this.price || this.list.arr[this.list.active],
                // money: 0.01,
                payType,
                userName: this.vuex_userInfo.nickName,
                returnUrl: 'http://www.baidu.com'
            }).then(res => {
                this.loading = false
                this.qrCode.show = true

                this.payTitle = payType == 'wxpay' ? '微信支付' : '支付宝支付'

                this.$nextTick(_ => {
                    const container = this.$refs.qrcode;
                    while (container.firstChild) {
                        container.removeChild(container.firstChild);
                    }
                    new QRCode(this.$refs.qrcode, {
                        text: res.data.codeUrl,
                        width: 128 * 2,
                        height: 128 * 2
                    });
                })
            })
        },
    }
}
</script>

<style lang="scss" scoped>
// 充值说明
.recharge_instructions {
    line-height: 26px;
    font-size: 13px;
    font-weight: bold;
    .tit {
        color: red;
        font-size: 16px;
    }
}
.chongzhi {
    .tit {
        font-weight: bold;
        font-size: 30px;
        margin: 20px 0;
    }

    .list {
        display: flex;
        flex-wrap: wrap;

        > div {
            text-align: center;
            background-color: orange;
            width: 20%;
            padding: 10px 0px;
            color: #ffffff;
            margin-right: 30px;
            margin-bottom: 30px;
            border-radius: 10px;
            cursor: pointer;

            &.active {
                background-color: orangered;
            }

            > div {
                font-size: 20px;
            }
        }
    }

    .chongzhifangshi {
        font-size: 28px;
        margin: 50px 0;

        span {
            border-radius: 10px;
            /* overflow: hidden; */
            margin-right: 50px;
            background-color: #409eff;
            color: #ffffff;
            padding: 10px 50px;
            display: inline-block;
            box-sizing: border-box;
            cursor: pointer;
        }
    }
}
</style>
